import clsx from 'clsx';

export default function GalleryButton(
  props: React.ComponentPropsWithoutRef<'button'>
) {
  const { className, children, ...btnProps } = props;

  return (
    <button
      {...btnProps}
      className={clsx(
        'bg-slate-50 rounded-full px-5 py-2 color text-teal-50 font-semibold',
        className
      )}
    >
      {children}
    </button>
  );
}
